/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import ContextMenuHeaderCss from "./css/ContextMenuHeader.css";
import { MenuItem } from "@react/react-spectrum/Menu";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";
import withToolTip from "dc-preview-utils//src/HOC/withToolTip";
import { TOOLTIP } from "dc-preview-utils/src/Constants/constants";

const ContextMenuHeader = props => {
  const { menuItems, noBody, getExtraParams, clearTouchSelectionIfPresent } = props;

  const clickHandler = (menuItem, eventObj) => {
    let eventHandler = menuItem.eventHandler;
    let args = menuItem.args || [];
    eventHandler(...args, getExtraParams());
    clearTouchSelectionIfPresent();
    if (menuItem.stayOpenOnSelect) {
      eventObj.stopPropagation();
      eventObj.preventDefault();
    }
  };

  return (
    <div className={`${ContextMenuHeaderCss.ContextMenuHeaderWrapper} ${noBody ? ContextMenuHeaderCss.noBody : ""}`}>
      {menuItems.map((menuItem, i) => {
        if (menuItem.tooltip) {
          return (
            <MenuItemComponentWithToolTip
              i={i}
              menuItem={menuItem}
              tooltip={{ text: menuItem.tooltip, placement: TOOLTIP.PLACEMENT.TOP, trigger: "hover" }}
              clickHandler={clickHandler}
            />
          );
        }
        return <MenuItemComponent i={i} menuItem={menuItem} clickHandler={clickHandler} />;
      })}
    </div>
  );
};

const MenuItemComponent = ({ i, menuItem, clickHandler }) => (
  <MenuItem
    key={i}
    className={ContextMenuHeaderCss.ContextMenuHeaderButton}
    onClick={e => clickHandler(menuItem, e)}
    icon={menuItem.icon && <CustomIcon url={menuItem.icon} />}
    aria-label={menuItem.title}
  />
);
const MenuItemComponentWithToolTip = withToolTip(MenuItemComponent);

export { ContextMenuHeader };
